import { createAction } from '@mews/framework';
import { DATA_TO_FETCH_SET, FETCH_FLAG_SET } from '../actionTypes';
import { DataType } from '../types';

export const setFetchFlag = (flagValue: boolean) => createAction(FETCH_FLAG_SET, flagValue);
export const setDataToFetch = (dataType: DataType | null, dataToFetch: string | null) =>
    createAction(DATA_TO_FETCH_SET, { dataType, dataToFetch });
